const React = require("react");

import "core-js/stable";
import "regenerator-runtime/runtime";

import { combineReducers, createStore } from 'redux';
import { Provider } from 'react-redux';

import Injector from 'lib/Injector'; // eslint-disable-line
import { loadComponent } from 'lib/Injector'; // eslint-disable-line

import Register from '../../../mfa/client/src/components/BackupCodes/Register';
import Verify from '../../../mfa/client/src/components/BackupCodes/Verify';
import MFARegister from '../../../mfa/client/src/components/Register';
import RegisteredMFAMethodListField from '../../../mfa/client/src/components/FormField/RegisteredMFAMethodListField/RegisteredMFAMethodListField';

import mfaRegisterReducer from '../../../mfa/client/src/state/mfaRegister/reducer';
import mfaVerifyReducer from '../../../mfa/client/src/state/mfaVerify/reducer';
import mfaAdministrationReducer from '../../../mfa/client/src/state/mfaAdministration/reducer';

import WithSudoMode from './SudoMode.jsx';

let store = null;

class MFASettings extends React.Component {
	componentWillMount() {
		if (Injector.initialised) {
			return;
		}

		Injector.component.registerMany({
			MFARegister,
			RegisteredMFAMethodListField,
			BackupCodeRegister: Register,
			BackupCodeVerify: Verify,
		});

		Injector.transform('ProfileMFASettingsWithSudoMode', (updater) => {
			updater.component('RegisteredMFAMethodListField', WithSudoMode);
		});

		Injector.reducer.register('mfaAdministration', mfaAdministrationReducer);
		Injector.reducer.register('mfaRegister', mfaRegisterReducer);
		Injector.reducer.register('mfaVerify', mfaVerifyReducer);

		Injector.ready(() => {
			store = createStore(
				combineReducers(Injector.reducer.getAll())
			);
		});

		Injector.load();
	}

	render() {
		const {
			backupMethod,
			defaultMethod,
			registeredMethods,
			availableMethods,
			allAvailableMethods,
			resources,
			endpoints,
			backupCreatedDate,
			resetEndpoint,
			isMFARequired,
			sudoModeActive,
		} = this.props.model.MFA.schema;

		const { InitialSecurityID } = this.props.model;

		const RegisteredMFAMethodList = loadComponent('RegisteredMFAMethodListField');

		return (
			<div className='mfa-settings'>
				<Provider store={store}>
					<RegisteredMFAMethodList
						backupMethod={backupMethod}
						readOnly={false}
						initialDefaultMethod={defaultMethod}
						initialRegisteredMethods={registeredMethods}
						initialAvailableMethods={availableMethods}
						allAvailableMethods={allAvailableMethods}
						resources={resources}
						endpoints={endpoints}
						backupCreatedDate={backupCreatedDate}
						isMFARequired={isMFARequired}
						sudoModeActive={sudoModeActive}
						cancelSudoModeHandler={this.props.cancelHandler}
						SecurityID={InitialSecurityID}
					/>
				</Provider>
			</div>
		);
	}
}

module.exports = MFASettings;
